<template>
  <div class="notice-view">
    <ResourcesTable 
      :resources="paginatedResources"
      :current-page="currentPage"
      :per-page="perPage"
      :total="filteredResources.length" />

  <Pagination
    :total="filteredResources.length"
    :page="currentPage"
    :page-size="perPage"
    @change="changePage"
  />

    <SearchBar @search="handleSearch" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import SearchBar from "@/components/SearchBar.vue";
import Pagination from "@/components/Pagination.vue";
import ResourcesTable from "@/components/ResourcesTable.vue";
import axios from '@/utils/axios';

const resources = ref([]);
const keyword = ref({ field: "title", keyword: "" });
const currentPage = ref(1);
const perPage = 5;

// 페이지 로드 시 자료실 가져옴
onMounted(() => {
  getAllResources();
});

const getAllResources = () => {
  axios.get("/bx201/resource")
    .then((response) => {
      resources.value = response.data;
    })
    .catch(() => {
    });
};

const filteredResources = computed(() =>
  [...resources.value]
    .filter(n => {
      if (keyword.value.field === "content") {
        return (n.content || "").toLowerCase().includes((keyword.value.keyword || "").toLowerCase());
      } else {
        return (n.title || "").toLowerCase().includes((keyword.value.keyword || "").toLowerCase());
      }
    })
    .sort((a, b) => Number(b.id) - Number(a.id))
);


const paginatedResources = computed(() => {
  const start = (currentPage.value - 1) * perPage;
  return filteredResources.value.slice(start, start + perPage);
});

const handleSearch = (term) => {
  if (!term) return;
  keyword.value = term; // { field, keyword } 전체 저장
  currentPage.value = 1;
};

const changePage = (page) => {
  currentPage.value = page;
};
</script>

<style scoped>
.notice-view {
  padding: 80px 16px;
  max-width: 1000px;
  margin: 0 auto;
}

</style>